<template>
  <div class="about-us">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 顶部大图 -->
      <section class="banner-section">
        <img src="@/assets/images/wenjpg.png" alt="服务范围" class="banner-image">
      </section>

      <!-- 合作院校部分54 -->
      <section class="news-section">
        <div class="container">
          <div class="news-header">
            <h2 class="section-title">{{ $t('xqnews.xqnews01') }}</h2>
          </div>
          <div class="news-content">
            <article class="cooperation-article">
              <!-- 图片展示 -->
              <div class="images-container">
                <div class="image-wrapper">
                  <img src="@/assets/images/news/xiaoqi/anli01.png" alt="同济大学合作案例1" class="cooperation-image">
                  
                </div>
                <div class="image-wrapper">
                  <img src="@/assets/images/news/xiaoqi/anli02.png" alt="同济大学合作案例2" class="cooperation-image">
                   
                </div>
              </div>

              <!-- 文字内容 -->
              <div class="content-text">
                <div class="content-section">
                  <h3 class="content-subtitle">{{ $t('xqnews.xqnews02') }}</h3>
                  <p class="content-paragraph">
                    {{ $t('xqnews.xqnews03') }}<span  style="font-weight: bold;">{{ $t('xqnews.xqnews04') }}</span>
                  </p>
                   <p class="content-paragraph">
                       {{ $t('xqnews.xqnews05') }}

                  </p>
                </div>
 

                
              </div>
            </article>
          </div>
        </div>
      </section>
       <!-- 合作院校部分55 -->
      <section class="news-section" style=" background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);">
        <div class="container">
          <div class="news-header">
            <h2 class="section-title">  {{ $t('xqnews.xqnews06') }}</h2>
          </div>
          <div class="news-content">
            <article class="cooperation-article">
              <!-- 图片展示 -->
              <div class="images-container">
                <div class="image-wrapper">
                  <img src="@/assets/images/news/xiaoqi/anli03.png" alt="同济大学合作案例1" class="cooperation-image">
                  
                </div>
                <div class="image-wrapper">
                  <img src="@/assets/images/news/xiaoqi/anli04.png" alt="同济大学合作案例2" class="cooperation-image">
                   
                </div>
              </div>

              <!-- 文字内容 -->
              <div class="content-text">
                <div class="content-section">
                  <h3 class="content-subtitle">{{ $t('xqnews.xqnews02') }}</h3>
                  <p class="content-paragraph">
                       {{ $t('xqnews.xqnews08') }}
                  </p>
                   <p class="content-paragraph">
                     {{ $t('xqnews.xqnews09') }}<span  style="font-weight: bold;">{{ $t('xqnews.xqnews010') }}</span>
                  </p>
                   <p class="content-paragraph">
                       {{ $t('xqnews.xqnews011') }}
                  </p>
                </div>
 

                
              </div>
            </article>
          </div>
        </div>
      </section>

      
      <!-- 合作院校部分56 -->
      <section class="news-section">
        <div class="container">
          <div class="news-header">
            <h2 class="section-title">{{ $t('xqnews.xqnews012') }}</h2>
          </div>
          <div class="news-content">
            <article class="cooperation-article">
              <!-- 图片展示 -->
              <div class="images-container">
                <div class="image-wrapper">
                  <img src="@/assets/images/news/xiaoqi/anli05.png"  class="cooperation-image">
                  
                </div>
                <div class="image-wrapper">
                  <img src="@/assets/images/news/xiaoqi/anli06.png"  class="cooperation-image">
                   
                </div>
              </div>

              <!-- 文字内容 -->
              <div class="content-text">
                <div class="content-section">
                  <h3 class="content-subtitle">{{ $t('xqnews.xqnews013') }}</h3>
                  <p class="content-paragraph">
                    {{ $t('xqnews.xqnews014') }}<span  style="font-weight: bold;"> 
                    {{ $t('xqnews.xqnews015') }}</span>{{ $t('xqnews.xqnews016') }}

                  </p>
                   <p class="content-paragraph">
                          {{ $t('xqnews.xqnews017') }} 
                  </p>
                </div>
 

                
              </div>
            </article>
          </div>
        </div>
      </section>
       <!-- 合作院校部分57 -->
      <section class="activity-review-section">
        <div class="container">
          <!-- 左侧：翻译实习基地 -->
          <div class="activity-row-double">
            <div class="double-images-container">
              <div class="double-image-item">
                <img src="@/assets/images/news/xiaoqi/anli07.png" alt="四川外国语大学翻译实习基地建设" class="activity-img">
              </div>
              <div class="double-image-item">
                <img src="@/assets/images/news/xiaoqi/anli08.png" alt="翻译实习基地合作签约" class="activity-img">
              </div>
            </div>
            <div class="double-text-container">
              <p class="activity-text">  {{ $t('xqnews.xqnews018') }} </p>
            </div>
          </div>
          
          <!-- 右侧：授课活动 -->
          <div class="activity-row-double">
            <div class="double-images-container">
              <div class="double-image-item">
                <img src="@/assets/images/news/xiaoqi/anli09.png" alt="四川外国语大学德语系授课现场" class="activity-img">
              </div>
              <div class="double-image-item">
                <img src="@/assets/images/news/xiaoqi/anli10.png" alt="德语专业学生课堂互动" class="activity-img">
              </div>
            </div>
            <div class="double-text-container">
              <p class="activity-text">  {{ $t('xqnews.xqnews019') }} </p>
            </div>
          </div>
        </div>
        
        <!-- 活动详情描述 -->
        <div class="activity-description">
          <div class="description-text">
              {{ $t('xqnews.xqnews020') }} 
            <div style="margin-top:0.5rem;">{{ $t('xqnews.xqnews021') }} </div>
             <div style="margin-top:0.5rem;">{{ $t('xqnews.xqnews021a') }} </div>
              <div style="margin-top:0.5rem;">{{ $t('xqnews.xqnews021b') }} </div>
               <div style="margin-top:0.5rem;">{{ $t('xqnews.xqnews021c') }} </div>
                <div style="margin-top:0.5rem;">{{ $t('xqnews.xqnews021d') }} </div>
                <div style="margin-top:0.5rem;">{{ $t('xqnews.xqnews021f') }} </div>
           <div style="margin-top:0.5rem;">   {{ $t('xqnews.xqnews022') }} </div>
          </div>
         
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'XiaoQiNews',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      
    }
  }
}
</script>

<style scoped>
.about-us {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 顶部大图部分 */
.banner-section {
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: relative;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 新闻详情部分 */
.news-section {
  background-color: #FFF5F0;
  padding: 3rem 0;
}

.news-header {
  margin-bottom: 2rem;
}

.news-header .section-title {
  color: #FF631E;
  font-size: 2.2rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 2rem;
}

.news-content {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 3rem;
}

/* 文章样式 */
.cooperation-article {
  max-width: 1000px;
  margin: 0 auto;
}

/* 图片展示区域 */
.images-container {
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
  justify-content: center;
}

.image-wrapper {
  position: relative;
  flex: 1;
  max-width: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(255, 99, 30, 0.2);
  transition: all 0.3s ease;
}

.image-wrapper:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 99, 30, 0.4);
}

.cooperation-image {
  width: 100%;
  height: 250px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.image-wrapper:hover .cooperation-image {
  transform: scale(1.05);
}

/* 图片遮罩 */
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 99, 30, 0.9), rgba(255, 140, 66, 0.9));
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 1.5rem;
}

.image-wrapper:hover .image-overlay {
  opacity: 1;
}

.overlay-content {
  text-align: center;
}

.overlay-content h4 {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.overlay-content p {
  font-size: 1rem;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 内容区域 */
.content-text {
  line-height: 1.8;
}

.content-section {
  margin-bottom: 2.5rem;
}

.content-section:last-child {
  margin-bottom: 0;
}

.content-subtitle {
  font-size: 1.5rem;
  font-weight: 600;
  color: #FF631E;
  margin-bottom: 1rem;
  position: relative;
  padding-left: 1rem;
}

.content-subtitle::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 1.2rem;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 2px;
}

.content-paragraph {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 1.5rem;
  text-align: justify;
}

/* 成果展示 */
.achievements-section {
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  margin-bottom: 2.5rem;
}

.achievements-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.achievement-item {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.achievement-item:hover {
  transform: translateY(-3px);
}

.achievement-icon {
  font-size: 2rem;
  margin-right: 1rem;
}

.achievement-content h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.3rem 0;
}

.achievement-content p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

/* 合作亮点 */
.highlights-section {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 99, 30, 0.1);
}

.highlight-box {
  margin-top: 1.5rem;
}

.highlight-item {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.highlight-item:last-child {
  border-bottom: none;
}

.highlight-label {
  font-weight: 600;
  color: #2c3e50;
  min-width: 120px;
  margin-right: 1rem;
}

.highlight-value {
  color: #FF631E;
  font-weight: 500;
}

/* 通用样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
  
  .banner-section {
    height: 400px;
  }
}

@media (max-width: 992px) {
  .banner-section {
    height: 350px;
  }
  
  .news-content {
    padding: 2rem;
  }
  
  .achievements-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }
  
  .banner-section {
    height: 300px;
  }
  
  .news-section {
    padding: 2rem 0;
  }
  
  .news-content {
    padding: 1.5rem;
  }
  
  .images-container {
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .image-wrapper {
    max-width: 100%;
  }
  
  .achievements-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .achievement-item {
    padding: 1rem;
  }
  
  .highlight-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 0.8rem 0;
  }
  
  .highlight-label {
    min-width: auto;
    margin-right: 0;
    margin-bottom: 0.3rem;
  }
  
  /* 活动回顾平板响应式 */
  .activity-review-section .container {
    flex-direction: column;
    gap: 2.5rem;
  }
  
  .activity-row-double {
    padding: 1.8rem;
  }
  
  .double-images-container {
    gap: 1rem;
    margin-bottom: 1.2rem;
  }
  
  .activity-img {
    height: 180px;
  }
  
  .activity-text {
    font-size: 1.05rem;
    padding: 0.9rem;
  }
  
  .activity-text::before {
    width: 50px;
  }
  
  /* 活动描述平板响应式 */
  .activity-description {
    width: 90%;
    margin-top: 1.5rem;
    padding: 0 1.5rem;
  }
  
  .description-text {
    font-size: 1rem;
    padding: 1.5rem;
  }
  
  .description-text::before {
    font-size: 2rem;
    top: 8px;
    left: 15px;
  }
}

/* 活动回顾部分样式 */
.activity-review-section {
  background-color: #FFF5F0;
  padding: 3rem 0;
}

.activity-review-section .container {
  display: flex;
  gap: 3rem;
  align-items: flex-start;
}

/* 双图片行容器 */
.activity-row-double {
  flex: 1;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  transition: all 0.3s ease;
}

.activity-row-double:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

/* 双图片容器 */
.double-images-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.double-image-item {
  flex: 1;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.double-image-item:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.activity-img {
  width: 100%;
  height: 200px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.double-image-item:hover .activity-img {
  transform: scale(1.05);
}

/* 文字容器 */
.double-text-container {
  text-align: center;
}

.activity-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-radius: 8px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  position: relative;
}

.activity-text::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
}

/* 活动描述部分 */
.activity-description {
  width: 1200px;
  margin: 2rem auto 0;
  padding: 0 2rem;
}

.description-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  text-align: justify;
  margin: 0;
  padding: 2rem;
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  border-radius: 12px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  position: relative;
}

.description-text::before {
  content: '"';
  position: absolute;
  top: 10px;
  left: 20px;
  font-size: 2.5rem;
  color: #FF631E;
  font-family: serif;
  opacity: 0.3;
}

@media (max-width: 576px) {
  .container {
    padding: 0 1rem;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  .banner-section {
    height: 250px;
  }
  
  .news-content {
    padding: 1rem;
  }
  
  .content-paragraph {
    font-size: 1rem;
  }
  
  .content-subtitle {
    font-size: 1.3rem;
  }
  
  .cooperation-image {
    height: 200px;
  }
  
  .achievements-section,
  .highlights-section {
    padding: 1.5rem;
  }
  
  .achievement-item {
    flex-direction: column;
    text-align: center;
    padding: 1rem;
  }
  
  .achievement-icon {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }
  
  .overlay-content h4 {
    font-size: 1.1rem;
  }
  
  .overlay-content p {
    font-size: 0.9rem;
  }
  
  /* 活动回顾响应式 */
  .activity-review-section .container {
    flex-direction: column;
    gap: 2rem;
  }
  
  .activity-row-double {
    padding: 1.5rem;
  }
  
  .double-images-container {
    gap: 0.8rem;
    margin-bottom: 1rem;
  }
  
  .activity-img {
    height: 150px;
  }
  
  .activity-text {
    font-size: 1rem;
    padding: 0.8rem;
  }
  
  .activity-text::before {
    width: 40px;
    height: 2px;
  }
  
  /* 活动描述手机响应式 */
  .activity-description {
    width: 100%;
    margin-top: 1rem;
    padding: 0 1rem;
  }
  
  .description-text {
    font-size: 0.95rem;
    line-height: 1.6;
    padding: 1.2rem;
    border-radius: 8px;
  }
  
  .description-text::before {
    font-size: 1.8rem;
    top: 5px;
    left: 10px;
  }
}

/* PC端横向布局 */
@media (min-width: 769px) {
  .activity-review-section .container {
    flex-direction: row;
    gap: 0rem;
    align-items: flex-start;
  }
}

.section-title {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #333;
}

/* 关于我们内容样式 */
.about-content {
  padding: 4rem 0;
}

.about-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  align-items: center;
}

.about-image {
  flex: 1;
  min-width: 300px;
}

.about-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.about-text {
  flex: 1;
  min-width: 300px;
}

.about-paragraph {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #666;
}

/* 价值观部分样式 */
.values-section {
  background-color: #f8f9fa;
  padding: 4rem 0;
}

.values-section .section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.value-card {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
}

.value-icon {
  font-size: 2.5rem;
  color: #007bff;
  margin-bottom: 1.5rem;
}

.value-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.value-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
}

/* 顶部大图部分 */
.banner-section {
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: relative;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 行业活动精彩回顾板块样式 */
.activity-review-section {
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  padding: 4rem 0;
  position: relative;
}

.activity-review-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #FF631E, transparent);
}

.activity-review-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 0rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.activity-review-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 第一行：单张图片布局 */
.activity-row-single {
  margin-bottom: 3rem;
  background: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>